// MIRRORS: panel/components/produceIcon/produceArt.ts — identical copy; edit both, or delete this line on both to declare a deliberate split.
import placements from '@/assets/produce/placements.json';

/**
 * The design team's produce art. Each piece keeps the size and offset it was drawn at inside
 * the pin's disc; the images and placements.json are generated together, never hand-edited.
 */
export interface ProduceArt {
  url: string;
  /** Left, top, width, height inside the disc's square, each 0..1. */
  x: number;
  y: number;
  w: number;
  h: number;
}

/** What a produce icon draws: the art when there is any, the emoji otherwise. */
export interface ProduceIconSource {
  art: ProduceArt | null;
  emoji: string;
}

// Hashed URLs, not inlined bytes: the browser fetches only the art on screen
// and caches it for good.
const urls = import.meta.glob<string>('../../assets/produce/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
});

const ART = new Map<string, ProduceArt>(
  Object.entries(placements).flatMap(([key, placement]) => {
    const url = urls[`../../assets/produce/${key}.png`];
    return url ? [[key, { url, ...placement }] as const] : [];
  })
);

/**
 * The art behind a key from the API. A key the build does not know — the DB
 * got ahead of the deploy, or a typo — is no art, never a broken image.
 */
export function produceArt(key: string | null | undefined): ProduceArt | null {
  return (key && ART.get(key)) || null;
}

/** For a category or product row: its own art, else its own emoji. */
export function iconSourceOf(item: { icon: string; iconKey?: string }): ProduceIconSource {
  return { art: produceArt(item.iconKey), emoji: item.icon };
}
